// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9f6650d7","837":"44620437"}[chunkId] + ".chunk.js";
};